import getS3Data from './s3-data-service';
import routeConfig from '../flippersConfig.json';

const getFlippersFromS3 = async (s3Key, s3PrimaryBucket) => {
  let flippers = {};
  const flipperS3 = await getS3Data({ Bucket: s3PrimaryBucket, Key: s3Key });
  if (flipperS3.errMsg !== 'success') {
    return new Error(`No flipper found for ${s3Key} or you might not have access to the s3`, 'error');
  }

  if (flipperS3?.s3Data?.length !== 0) {
    flippers = flipperS3.s3Data;
  }
  return flippers;
};

const getFlipperData = async (config, isNP) => {
  const s3PrimaryBucket = isNP ? routeConfig.S3BucketPrimarynp : routeConfig.S3BucketPrimary;

  if (config) {
    const globalFlippersS3Key = `Global/${config}.json`;

    const globalFlippers = await getFlippersFromS3(globalFlippersS3Key, s3PrimaryBucket);

    if (Object.keys(globalFlippers).length !== 0) {
      // if there are at least global flippers, return those
      return { ...globalFlippers };
    }

    return new Error('Error fetching flippers');
  }

  return new Error('Error with provided config and bounded context for fetching flippers.');
};

const getConfig = (nodeEnv) => {
  const isNP = nodeEnv && nodeEnv !== 'production';
  const config = isNP ? 'nonprod' : 'prod';
  return ({
    isNP,
    config,
  });
};

export const getFlippers = async () => {
  let s3flippers;
  try {
    const configObj = getConfig(process.env.NODE_ENV);
    s3flippers = await getFlipperData(configObj.config, configObj.isNP);
    if (s3flippers instanceof Error) {
      throw s3flippers;
    }
    return s3flippers;
  } catch (e) {
    console.log(`error getting flippers. error information: ${e}`);
  }
};

export const isFlipperOn = async (flipperName) => {
  try {
    const flippers = await getFlippers();
    return flippers && flippers[flipperName] && flippers[flipperName].Enabled === true;
  } catch (e) {
    console.log(`error getting flipper status for flipperName: ${flipperName}. error information: ${e}`);
  }
};
